import { useModalStore } from "@/hooks/Modal/hooks";
import { batchRecognizeConsignee } from "@/services/api/manualOrder";
import { useRequest } from "ahooks";
import { Button, Modal } from "antd";
import React from "react";
import BatchInputModal from "./BatchInputModal";

interface BatchRecognizeAddressButtonProps {
    /**待识别的地址 */
    value?: string;
    shopId: number;
    onResetFullForm: () => void;
}

const BatchRecognizeAddressButton: React.FC<BatchRecognizeAddressButtonProps> = function (props) {
    const { shopId, value, onResetFullForm } = props;
    const { runAsync, loading } = useRequest(batchRecognizeConsignee, { manual: true });
    const modalStore = useModalStore();

    async function handleRecognizeAddress() {
        if (!value) {
            return Modal.error({
                title: "请先填写收货人信息",
            });
        }

        const texts = value
            .split("\n")
            .map((it) => it?.trim())
            .filter(Boolean);

        const consignees = await runAsync(shopId, texts);

        if (consignees.length) {
            modalStore.openModal(BatchInputModal, {
                shopId,
                consignees,
                onDone() {
                    onResetFullForm();
                },
            });
        }
    }

    return (
        <Button
            loading={loading}
            onClick={handleRecognizeAddress}
            className="mt5 mr5 ant-btn-warning"
            size="small"
            type="primary"
        >
            批量识别地址
        </Button>
    );
};

export default BatchRecognizeAddressButton;
